// extracted by mini-css-extract-plugin
module.exports = {"folderIconGroup":"FolderIcon_folderIconGroup__2S9j_","folderIcon":"FolderIcon_folderIcon___h3Ol","folderCaret":"FolderIcon_folderCaret__2guFh"};